module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(_vm.isYoutube) ? _c('iframe', {
    staticClass: "partial-video",
    attrs: {
      "width": "576",
      "height": "324",
      "src": _vm.source,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : _vm._e(), (_vm.isPrivate) ? _c('video', {
    ref: "videojs",
    staticClass: "partial-video video-js vjs-default-skin vjs-big-play-centered vjs-16-9",
    class: {
      nocontrol: !_vm.controllable
    },
    attrs: {
      "width": "576",
      "height": "324"
    }
  }, [_c('p', {
    staticClass: "vjs-no-js"
  }, [_vm._v("Deze video kan niet afgespeeld worden.")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c7730d2","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/partials/VideoPartial.vue
// module id = dajq
// module chunks = 1